// import MapBoxMap from "./MapBoxMap";
import MapLibreMap from "./MapLibreMap";

export default class Factory {

    static getMap(config = {}) {
        return new MapLibreMap(config);
    }

}